<template>
  <div class='mine-studentMessage-grade-gradeAdd'>
    <div class="contentBox">
      <p class="subject">
        {{data.gradeName}}-{{data.nameName}}
        <a class="showJuxing">
          <span class="juxing blue"></span>
          <span>&gt;预期值5分/名以上</span>
          <span class="juxing red"></span>
          <span>&lt;预期值5分/名以上</span>
        </a>
      </p>
      <p class="totalScore">总分：{{data.totalScore}}</p>
      <table class="gradeTable">
        <thead>
        <tr style="background:#F0F9FE "></tr>
        <th width='130'>科目</th>
        <th width='100'>预期分数/排名</th>
        <th width='100'>实际分数</th>
        <th width='100'>单科排名</th>
        <th width='120'>选考人数</th>
        <th>考试说明</th>
        </thead>
        <tbody>
        <tr v-for="(item,index) in data.subject" :key="index">
          <td style="background:#FAFDFF ">{{item.subject}}</td>
          <td>{{item.targetScore}}/{{item.targetRank}}</td>
          <td :class="item.score>(item.targetScore+5)&&'colorBlue'||(item.score<(item.targetScore-5)&&'colorRed')||''">{{item.score||0}}</td>
          <td :class="item.rank>(item.targetRank+5)&&'colorBlue'||(item.rank<(item.targetRank-5)&&'colorRed')||''">{{item.rank||0}}</td>
          <td>{{item.totalPeople||0}}</td>
          <td>
            <p style="display: flex;align-items: center;line-height: 24px;justify-content: center;padding: 0 10px">
              {{item.remark}}
            </p>
          </td>
        </tr>
        </tbody>
      </table>
      <div class="summary">
        <SummaryTitle title="考试总结"></SummaryTitle>
        <el-input type="textarea"  :value="data.remark" disabled></el-input>
      </div>
    </div>

  </div>
</template>
<script>
import SummaryTitle from "@/components/xueyezixun/SummaryTitle";
import Button from "@/components/xueyezixun/Button";

export default {
  components:{SummaryTitle,Button},
  props:['id','getDatas'],
  data() {
    return {
      data:{},
      ids:''
    }
  },
  methods: {
    getGradeData(name){
      this.$ajax.post(this.G_acapi+ this.ports.student.student.implement.getCurrentSemesterConditionalGoals, {
        name:name
      }, {
        headers: {
          token: window.sessionStorage.getItem('ymtxToken')
        }
      }).then((res) => {
        if (res.data.code == 2000) {
          if(res.data.data.condition.length==0){
            return;
          }
          let result=JSON.parse(res.data.data.condition);
          // console.log(result)
          if(result.length>0){
            let kemu = result[0].kemu;
            let xueye=result[0].xueye;
            kemu.push({
              name:'总分',
              score:xueye[0].value,
              rank:xueye[1].value
            })
            const {data}=this;
            data.subject.forEach((item,key)=>{
             item.score=item.score?item.score:0
              item.targetScore = item.targetScore?item.targetScore:0
              item.rank =item.rank?item.rank:0
              item.targetRank =item.targetRank?item.targetRank:0
              kemu.forEach((it,i)=>{
                if(item.subject==it.name){
                  item.targetScore=it.score
                  item.targetRank=it.rank
                }
              })
            })
            this.data=JSON.parse(JSON.stringify(data))
            this.getDatas(data)
          }
        }else{

        }
      })
    },
    getData(){
      this.$ajax.post(this.G_acapi+ this.ports.student.student.studentMessage.grade.detailAchievementByStudent, {
        id:this.$route.query.gradeDetailId
      }, {
        headers: {
          token: window.sessionStorage.getItem('ymtxToken')
        }
      }).then((res) => {
        if (res.data.code == 2000) {
          let data=res.data
          data.data.subject.push({
            subject:'总分',
            score:data.data.totalScore,
            rank:data.data.totalRank,
            totalPeople:data.data.totalPeople
          })
          this.data=data.data;
          this.$nextTick(()=>{
            this.getGradeData(data.data.gradeName)
          })

        }else{

        }
      })
    },
  },
  mounted() {
    this.getData()
  }
}
</script>
<style scoped lang="less">
.showJuxing{
  display: inline-block;
  margin-left: 40px;
  .juxing{
    display: inline-block;
    width: 10px;
    height: 10px;
  }
  .blue{
    background: #00A2FF;
  }
  .red{
    background: #E23D7F;
    margin-left: 20px;
  }
  span{
    color: #5C5C5C;
    font-size: 14px;
  }
}
.colorBlue{
  color: #00A2FF;
}
.colorRed{
  color:#E23D7F;
}
@import "./css/gradeAdd.less";
@import "./css/index.less";
</style>
<style lang="less">
.mine-studentMessage-grade-gradeAdd{
  textarea{
    min-height: 140px !important;
  }
}
</style>